import { connect } from 'react-redux';
import { push as pushAction } from 'react-router-redux';
import Home from './components/Home';

export const mapStateToProps = () => ({});

export const mapActionCreators = {
    pushAction
};

export default connect(
    mapStateToProps,
    mapActionCreators
)(Home);
